import { usePaymentGateway } from '../gateway/gateway.hooks'
import { type PaymentGatewayOptions } from '../gateway/gateway.types'

export const usePayment = (options: PaymentGatewayOptions = {}) => {
  return usePaymentGateway(options)
}
